var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1499,1c0,499.4,0,998.7,0,1498.1c-499.3,0-998.7,0-1498,0C1,999.7,1,500.3,1,1C500.3,1,999.7,1,1499,1z M891.1,1238.6 c10.5,15.7,17.7,28,26.3,39.1c69.7,90,194.7,126.4,315,93.6c83.7-22.8,138.3-73,149-160.9c10.1-83.5-19-152.3-92.6-197.1 c-35.2-21.4-73.4-38-110.3-56.6c-24.3-12.2-49.5-22.9-73-36.5c-28.8-16.6-35.4-44-27.5-74.1c7.7-29.5,31-38.4,59.6-40.8 c45.8-3.8,71.8,23.6,94.8,58.7c36.9-23.9,72.3-47,108.5-70.5c-39.1-69.8-96.3-104.9-172.6-113.2c-100.8-11-196,40.9-224.5,125.1 c-31.6,93.5,6.5,189.9,98,242.9c29.6,17.1,61.9,29.3,92.7,44.3c25.5,12.4,54.4,21.4,74.7,39.7c16.3,14.8,32.1,42.9,29.3,62.4 c-2.8,19.6-25.4,43.4-45.2,52.3c-55.7,25.1-123.5,3.9-163.3-44.5c-8.1-9.9-15.7-20.2-24.1-30.9 C967.5,1194.1,930.8,1215.5,891.1,1238.6z M394,1252.6c46.5,94.4,122.9,131.8,219,130.3c124.6-1.9,198.3-71.6,201.3-195.5 c3.9-161.3,1.5-322.8,1.6-484.2c0-4.3-2.3-8.7-3.6-13.3c-45.8,0-90.2,0-138.6,0c0,16.5,0,30.4,0,44.3 c-0.3,149.6-0.5,299.1-0.9,448.7c-0.1,29.1-8.4,54.6-37.8,66.3c-33.9,13.4-65.8,8.2-91.8-17.8c-13.1-13.1-22.9-29.7-35.7-46.8 C470.3,1206.9,433,1229.3,394,1252.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.d6e29a48bdcd067fb0b62c078df3edb2.svg";
export { ForwardRef as ReactComponent };